import { render, staticRenderFns } from "./FrzOptionsAdvanced.vue?vue&type=template&id=dd47e388"
import script from "./FrzOptionsAdvanced.vue?vue&type=script&lang=js"
export * from "./FrzOptionsAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports